import React from 'react'
import parse from 'html-react-parser'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

import { MouseParallaxContainer, MouseParallaxChild } from 'react-parallax-mouse'

import {
  Content,
  PartnerSlider,
  heroClasses,
  heroContainerClasses,
  FloatingCircle,
  childStyles
} from '../Atoms'
import { MakeMore, ContactForm, MyMap } from '../Sections'
import Layout from '../Layout'
import { Fade } from 'react-awesome-reveal'

import { labels, localeUrls } from '../../langs/langs'

import hcP from '../../images/half-circle.svg'
import arrP from '../../images/arrow-top-right-green.svg'
import xxxP from '../../images/x-green.svg'
import circBP from '../../images/circle-blue.svg'
import pcloud1 from '../../images/pcloud-send.svg'
import pcloud2 from '../../images/pcloud-hello.svg'
import pcloud3 from '../../images/pcloud-phone.svg'
import pcloud4 from '../../images/pcloud-cloud.svg'

import phoneI from '../../images/phone-blue.svg'
import atI from '../../images/at-blue.svg'
import geoI from '../../images/location-blue.svg'

const ContactUs = ({ localeID, location }) => {
  return (
    <Layout location={location} title={labels[localeID]['CONTACT']} localeID={localeID}>
      <MouseParallaxContainer
        className={`${heroClasses} lg:h-[calc(100vh_-_10.75rem)]  max-h-[52rem]`}
      >
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.005} factorY={0.009}>
          <FloatingCircle
            basic={false}
            className="bg-blue w-[50vh] h-[50vh] lg:-bottom-[10vw] right-[13vw] lg:w-[75vh] lg:h-[75vh]"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={0.03} factorY={0.04}>
          <img src={hcP} className="hidden lg:block h-9 w-9 absolute top-[80%] right-[7vw] z-30" />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.03} factorY={0.02}>
          <img src={arrP} className="hidden lg:block h-9 w-9 absolute top-[60%] right-[9vw] z-30" />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.03} factorY={-0.02}>
          <img
            src={hcP}
            className="hidden lg:block h-9 w-9 absolute top-[20%] right-[15vw] z-30 rotate-90"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.01} factorY={-0.015}>
          <img
            src={arrP}
            className="hidden lg:block h-9 w-9 absolute top-[10%] right-[42vw] z-30"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.01} factorY={0.015}>
          <img
            src={circBP}
            className="hidden lg:block h-9 w-9 absolute top-[10%] right-[21vw] z-30"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={0.02} factorY={-0.01}>
          <img
            src={circBP}
            className="hidden lg:block h-9 w-9 absolute top-[35%] left-[45vw] z-30"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.02} factorY={0.04}>
          <img src={xxxP} className="hidden lg:block h-9 w-9 absolute top-[85%] left-[40vw] z-30" />
        </MouseParallaxChild>
        <StaticImage
          src="../../images/contact-person.png"
          alt="contact person"
          className="!absolute w-[66%] max-h-[90%] right-0 bottom-0"
          objectFit="contain"
          quality={90}
        />
        <Content className={heroContainerClasses}>
          <div className="hcenter z-30 relative">
            <div>
              <h1 className="text-5xl 2xl:text-6xl font-bold -tracking-[0.5px]">
                {labels[localeID]['CONTACT']}
              </h1>
              <div className="text-lg py-7">
                <Fade cascade={true} damping={0.1} triggerOnce={false}>
                  <a href="tel:+421(2) 32 606 511" className="hcenter py-1.5 font-bold">
                    <img className="h-7 w-7" src={phoneI} alt="check icon" />
                    <span>+421(2) 32 606 511</span>
                  </a>
                  <a href="mailto:office@ccstax.sk" className="hcenter py-1.5 font-bold">
                    <img className="h-7 w-7" src={atI} alt="check icon" />
                    <span>office@ccstax.sk</span>
                  </a>
                  <a className="hcenter py-1.5 font-bold">
                    <img className="h-7 w-7" src={geoI} alt="check icon" />
                    <span>Tomášikova 50/E, BA</span>
                  </a>
                </Fade>
              </div>
              <Link to={localeUrls[localeID]['CTA']} className="button2">
                {labels[localeID]['WORK_W_US']}
              </Link>
            </div>
          </div>
        </Content>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.01} factorY={0.01}>
          <img
            src={pcloud1}
            className="hidden lg:block w-40 absolute top-[38%] right-[5vw] 2xl:right-[13vw] z-30"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={-0.01} factorY={-0.015}>
          <img
            src={pcloud2}
            className="hidden lg:block w-24 absolute top-[62%] left-[38vw] 2xl:left-[47vw] z-30"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={0.02} factorY={0.015}>
          <img
            src={pcloud3}
            className="hidden lg:block w-28 absolute top-[70%] right-[20vw] z-30"
          />
        </MouseParallaxChild>
        <MouseParallaxChild updateStyles={childStyles} factorX={0.015} factorY={-0.015}>
          <img
            src={pcloud4}
            className="hidden lg:block w-28 absolute top-[38%] right-[40vw] z-30"
          />
        </MouseParallaxChild>
      </MouseParallaxContainer>
      <div className="py-24 sm:py-32">
        <Content>
          <h2 className="font-bold text-3xl -tracking-[0.4px]">{labels[localeID]['CONTACT_US']}</h2>
          <div className="grid pt-9 sm:grid-cols-[1fr_auto] gap-24 sm:gap-0">
            <ContactForm localeID={localeID} className="sm:pr-10 lg:pr-20 xl:pr-32" />
            <div className="sm:pl-10 lg:pl-20 xl:pl-32 border-l-dark-gray sm:border-l">
              <h3 className="text-2xl font-bold">CCS Tax, spol. s r.o.</h3>
              <p className="text-sm">Office</p>
              <div className="py-7">
                <Fade cascade={true} damping={0.1} triggerOnce={false}>
                  <a href="tel:+421(2) 32 606 511" className="hcenter py-1.5 font-bold">
                    <img className="h-7 w-7" src={phoneI} alt="check icon" />
                    <span>+421(2) 32 606 511</span>
                  </a>
                  <a href="mailto:office@ccstax.sk" className="hcenter py-1.5 font-bold">
                    <img className="h-7 w-7" src={atI} alt="check icon" />
                    <span>office@ccstax.sk</span>
                  </a>
                  <a className="hcenter py-1.5 font-bold items-start">
                    <img className="h-7 w-7" src={geoI} alt="check icon" />
                    <span>
                      Tomášikova 50/E, BA
                      <br />
                      <span className="font-normal">
                        831 04 Bratislava
                        <br />
                        Slovenská republika
                      </span>
                    </span>
                  </a>
                </Fade>
              </div>
              <p>
                <span className="font-bold">SKDP:</span> č. licencie 87/2009
              </p>
              <div className="py-7">
                <p>
                  <span className="font-bold">IČO:</span> 44 539 126
                </p>
                <p>
                  <span className="font-bold">DIČ:</span> 2022736166
                </p>
                <p>
                  <span className="font-bold">IČ DPH:</span> SK2022736166
                </p>
              </div>
              <p>
                Zápis v ORSR Mestský súd Bratislava III,
                <br /> oddiel: Sro, vložka č.: 176562/B
              </p>
            </div>
          </div>
        </Content>
      </div>
      <PartnerSlider />
      <MyMap localeID={localeID} />
      <MakeMore localeID={localeID} />
    </Layout>
  )
}

export default ContactUs
